import { __assign } from "tslib";
import { get } from "lodash";
import { isString } from "@ekuaibao/helpers";
import { fnSubstr16 } from "../flow-log-item";
import { getStaffName } from "../../../utilFn";
export function formatRegStr(regStr) {
    var result = regStr;
    if (result) {
        var reg = ['^', '+', '{', '}', '[', ']', '$', '/', '*', '|', '(', ')', '.', '（', '）', '?', '-'];
        reg.forEach(function (item) {
            if (!!~result.indexOf(item)) {
                var reg_1 = new RegExp("\\" + item, 'g');
                result = result.replace(reg_1, "\\" + item);
            }
        });
    }
    return result;
}
export function comment2MentionContent(comment, staffList, staffDisplayConfigField) {
    if (!comment || !staffList) {
        return comment;
    }
    var mentionContent = comment;
    staffList.forEach(function (item) {
        var regStr = formatRegStr(item.id);
        var reg = new RegExp("{" + regStr + "}", 'g');
        var staffDisplay = get(item, "" + staffDisplayConfigField);
        var itemClone = __assign({}, item);
        var name = getStaffName(itemClone);
        staffDisplay && isString(staffDisplay) && (itemClone.name = name + (" (" + fnSubstr16(staffDisplay) + ") "));
        mentionContent = mentionContent.replace(reg, " @" + name + " ");
    });
    return mentionContent;
}
export function containsMarkdownSyntax(text, noCheck) {
    if (noCheck === void 0) { noCheck = false; }
    if (noCheck) {
        return true;
    }
    var mdPatterns = [
        /^#{1,6}\s/,
        /\*\*[^*]+\*\*/,
        /\*[^*]+\*/,
        /!?\[.*?\]\(.+?\)/,
        /^[*-]\s/,
        /`{3}[\s\S]+?`{3}/,
        /`[^`]+?`/,
        /~~.+?~~/
    ];
    return isString(text) ? mdPatterns.some(function (p) { return p.test(text); }) : false;
}
export function isHtmlText(input) {
    if (!isString(input))
        return false;
    var str = String(input).trim();
    if (!str)
        return false;
    if (!/[<>]/.test(str))
        return false;
    var hasDoctypeOrComment = /<!DOCTYPE|<!--|<\?xml/i;
    var hasTagPair = /<([A-Za-z][\w:-]*)\b[^>]*>[\s\S]*?<\/\1>/;
    var hasSelfClosing = /<([A-Za-z][\w:-]*)\b[^>]*\/>/;
    if (hasDoctypeOrComment.test(str))
        return true;
    if (hasTagPair.test(str))
        return true;
    if (hasSelfClosing.test(str))
        return true;
    var stripped = str.replace(/<[^>]+>/g, '').trim();
    if (stripped === str && !/&[a-zA-Z#0-9]+;/.test(str))
        return false;
    var hasOpeningTag = /<([A-Za-z][\w:-]*)\b[^>]*>/.test(str);
    return hasOpeningTag;
}
